/*
  RichtextEditorComponent
  Full editor for RTDs
*/

import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { FormService } from '@app/shared/services';
import { FroalaHelper } from '@app/shared/services/vendor';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-richtext-editor',
  styleUrls: ['./richtext-editor.component.scss'],
  templateUrl: './richtext-editor.component.html'
})
export class RichtextEditorComponent implements OnInit {
  @Input() form: any;
  @Input() advancedRichTextEditor: boolean;

  constructor(public formService: FormService, public froalaHelper: FroalaHelper) {}

  ngOnInit() {}
}
